export const organizationSettingsSelector = state => state.organizationSettings;
